// Module
var code = "{{#visible}}\r\n    <div class=\"alert-selector\">\r\n        <terceraLabel text=\"{{label}}\" />\r\n\r\n        <div class=\"alert-selector-right\">\r\n            <accountSelector selectedItem=\"{{.account}}\" visible=\"{{.visible}}\" ignoreForceLinkingByAccount=\"true\" onlyOwnAccounts=\"true\"/>\r\n        </div>\r\n    </div>\r\n{{/}}";
// Exports
export default code;